var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 25,
    viewBox: "0 0 30 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8552 6.19998C18.1941 6.19998 17.6576 5.66343 17.6576 5.00233V3.20585H12.867V5.00233C12.867 5.66343 12.3304 6.19998 11.6693 6.19998C11.0082 6.19998 10.4717 5.66343 10.4717 5.00233V3.20585C10.4717 1.88484 11.546 0.810547 12.867 0.810547H17.6576C18.9786 0.810547 20.0529 1.88484 20.0529 3.20585V5.00233C20.0529 5.66343 19.5163 6.19998 18.8552 6.19998Z",
    fill: "#35435E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1138 16.8333C15.8982 16.9171 15.5868 16.977 15.2634 16.977C14.9401 16.977 14.6287 16.9171 14.3412 16.8093L0.891602 12.3301V21.4682C0.891602 23.2886 2.36471 24.7617 4.18515 24.7617H26.3417C28.1621 24.7617 29.6353 23.2886 29.6353 21.4682V12.3301L16.1138 16.8333Z",
    fill: "#35435E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6353 7.69784V10.4405L15.5509 15.1353C15.4551 15.1712 15.3592 15.1832 15.2634 15.1832C15.1676 15.1832 15.0718 15.1712 14.976 15.1353L0.891602 10.4405V7.69784C0.891602 5.87741 2.36471 4.4043 4.18515 4.4043H26.3417C28.1621 4.4043 29.6353 5.87741 29.6353 7.69784Z",
    fill: "#35435E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.d710bc6aabde3f80fa834e26aa925bfa.svg";
export { ForwardRef as ReactComponent };